const KEY = "ezspot_attribution_code";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

type Stored = { code: string; expires: number };

export function captureAttributionCode(code: string) {
  if (typeof window === "undefined") return;
  const item: Stored = { code, expires: Date.now() + TTL_MS };
  try {
    localStorage.setItem(KEY, JSON.stringify(item));
  } catch {
    // localStorage may be unavailable (private mode, quota exceeded)
  }
}

export function getStoredAttributionCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, expires } = JSON.parse(raw) as Stored;
    if (Date.now() > expires) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearAttributionCode() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
